import devConfig from './development.config'

export default Object.assign(devConfig, {
  peanutbutterBaseUrl: 'https://peanutbutter.pkds.it',
  appsBuilderBaseUrl: 'https://appsbuilder-qa.sandboxkids.io',
  facebookAppId: '132913590231010',
  excludedSkus: [
    'com.movile.playkids.giftcard.arco.sas.90.days',
    'com.movile.playkids.giftcard.arco.positivo.90.days',
    'com.movile.playkids.giftcard.arco.conquista.90.days',
    'com.movile.playkids.giftcard.arco.saedigital.90.days',
    'com.movile.playkids.giftcard.arco.pleno.90.days',
    'com.movile.playkids.giftcard.arco.90.days'
  ]
})
